module.exports = __webpack_public_path__ + "img/qiyeguanlixitong.b77ef370.png";